module.exports = __webpack_public_path__ + "img/content-1.20051922.png";